import { render, staticRenderFns } from "./SuccesModal.vue?vue&type=template&id=54ab5bd8&scoped=true&"
import script from "./SuccesModal.vue?vue&type=script&lang=js&"
export * from "./SuccesModal.vue?vue&type=script&lang=js&"
import style0 from "./SuccesModal.vue?vue&type=style&index=0&id=54ab5bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ab5bd8",
  null
  
)

export default component.exports